import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { cssVariablesResolver, theme } from "@how/design-system";
import { SessionProvider } from "./session";
import type { AppSupabaseClient } from "./supabase";

export interface AppProvidersProps {
  readonly client: AppSupabaseClient;
  readonly queryClient: QueryClient;
  readonly children: ReactNode;
}

/**
 * Provider stack shared by every HoW app: Mantine (theme, auto color scheme, the named surface tokens), TanStack
 * Query, session, modals, notifications.
 */
export function AppProviders({ client, queryClient, children }: AppProvidersProps) {
  return (
    <MantineProvider
      theme={theme}
      defaultColorScheme="auto"
      cssVariablesResolver={cssVariablesResolver}
    >
      <QueryClientProvider client={queryClient}>
        <SessionProvider client={client}>
          <ModalsProvider>
            <Notifications position="top-right" />
            {children}
          </ModalsProvider>
        </SessionProvider>
      </QueryClientProvider>
    </MantineProvider>
  );
}
